var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "composer-inline-select",
      class: { "composer-inline-select--largura-total": _vm.larguraTotal },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.close($event)
        }
      }
    },
    [
      _c(
        "button",
        {
          ref: "trigger",
          staticClass: "composer-inline-select__trigger ia-texto-auxiliar",
          class: { "composer-inline-select__trigger--open": _vm.open },
          attrs: {
            type: "button",
            disabled: _vm.disabled,
            "aria-haspopup": "true",
            "aria-expanded": String(_vm.open),
            "aria-label": _vm.soIcone ? _vm.label : null,
            title: _vm.soIcone ? _vm.tooltip || _vm.label : null
          },
          on: { click: _vm.toggle }
        },
        [
          _vm.icon
            ? _c("icon-svg", {
                attrs: {
                  name: _vm.icon,
                  size: _vm.tamanhoDoIcone,
                  color: _vm.triggerIconColor
                }
              })
            : _vm._e(),
          !_vm.soIcone ? _c("span", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
          !_vm.soIcone || _vm.soIconeComChevron
            ? _c("icon-svg", {
                staticClass: "composer-inline-select__chevron",
                class: {
                  "composer-inline-select__chevron--open": _vm.open,
                  "composer-inline-select__chevron--compacto": _vm.soIcone
                },
                attrs: {
                  name: "mdi-chevron-down",
                  size: _vm.soIcone ? 10 : 13,
                  color: "var(--neutral-400)"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.open
        ? _c(
            "div",
            {
              staticClass: "composer-inline-select__menu",
              class: [
                "composer-inline-select__menu--" + _vm.direcaoEfetiva,
                _vm.larguraTotal
                  ? "composer-inline-select__menu--largura-total"
                  : "composer-inline-select__menu--" + _vm.align
              ],
              style: _vm.estiloMenu,
              attrs: { role: "menu" },
              on: {
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "home",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.focusItemAt(0)
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "end",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.focarUltimo($event)
                  }
                ]
              }
            },
            [
              _c(
                "div",
                { ref: "lista", staticClass: "composer-inline-select__lista" },
                _vm._l(_vm.options, function(option, index) {
                  return _c(
                    "button",
                    {
                      key: index,
                      ref: "items",
                      refInFor: true,
                      staticClass:
                        "composer-inline-select__item ia-texto-corpo",
                      class: {
                        "composer-inline-select__item--active": option.active,
                        "composer-inline-select__item--highlighted":
                          index === _vm.highlightedIndex
                      },
                      attrs: {
                        type: "button",
                        role: "menuitem",
                        disabled: option.disabled,
                        "aria-pressed": String(!!option.active)
                      },
                      on: {
                        click: function($event) {
                          return _vm.select(option)
                        }
                      }
                    },
                    [
                      option.icon
                        ? _c("icon-svg", {
                            attrs: {
                              name: option.icon,
                              size: 16,
                              color: option.active
                                ? _vm.activeColor
                                : "var(--neutral-400)"
                            }
                          })
                        : _vm._e(),
                      _c(
                        "span",
                        { staticClass: "composer-inline-select__item-text" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "composer-inline-select__item-label"
                            },
                            [_vm._v(" " + _vm._s(option.label) + " ")]
                          ),
                          option.description
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "composer-inline-select__item-description ia-texto-auxiliar"
                                },
                                [_vm._v(" " + _vm._s(option.description) + " ")]
                              )
                            : _vm._e()
                        ]
                      ),
                      option.active
                        ? _c("icon-svg", {
                            staticClass: "composer-inline-select__check",
                            attrs: {
                              name: "mdi-check",
                              color: _vm.activeColor,
                              size: 14
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              ),
              _vm.rodape
                ? _c(
                    "p",
                    {
                      staticClass:
                        "composer-inline-select__rodape ia-texto-auxiliar",
                      attrs: { "aria-hidden": "true" }
                    },
                    [_vm._v(" " + _vm._s(_vm.rodape) + " ")]
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }